module.exports = __webpack_public_path__ + "img/IconError.a5249bd6.svg";